module.exports = __webpack_public_path__ + "img/magazzino.24bb8875.png";